import _ from 'lodash';

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Checkbox from 'rc-checkbox';
import { RadioGroup, Radio } from 'components/Radio';
import Loading from 'components/Loading/Loading';
import { getIssueQuestions, answerIssueSurvey } from 'actions/issueQuestionActions';

import BackLink from '../../BackLink';

import './style.css';

class IssueSurvey extends Component {
  constructor() {
    super();
    this.state = {
      answers: {},
      refundRequested: false
    };
  }

  componentWillMount() {
    const issueId = this.props.routeParams.id;
    if (!issueId) {
      browserHistory.push({
        pathname: '/report-problem'
      });
      return;
    }

    // TODO: If issue is null, fetch it with the issueId but for now we just send back
    const { issue } = this.props.location.state;
    if (!issue) {
      browserHistory.push({
        pathname: '/report-problem'
      });
      return;
    }

    // TODO: If issueType is null, fetch it with the issue but for now we just send back
    const { issueType } = this.props.location.state;
    if (!issueType) {
      browserHistory.push({
        pathname: '/report-problem'
      });
      return;
    }

    this.props.getIssueQuestions(issue.issueTypeId);
  }

  handleSubmit = () => {
    const data = { answers: {} };
    data.answers = this.state.answers;
    data.refundRequested = this.state.refundRequested;
    this.props.answerIssueSurvey(this.props.routeParams.id, data, browserHistory);
  }

  handleAnswerChange = (questionId, value) => {
    const answers = { ...this.state.answers };
    answers[questionId] = value;
    this.setState({ answers });
  }

  handleRequestRefund = (e) => {
    this.setState({ refundRequested: e.target.checked });
  }

  isSubmitDisabled = () => {
    if (this.props.issueQuestions.status === 'SUBMITTING') {
      return true;
    }

    let disabled = false;
    _.each(this.props.issueQuestions.issueQuestions, issueQuestion => {
      disabled =
        disabled ||
        ((this.state.answers[issueQuestion.id] === undefined ||
          this.state.answers[issueQuestion.id] === null) &&
          issueQuestion.answerFormat.required === true);
    });
    return disabled;
  }

  renderRadioField(issueQuestion) {
    return (
      <div className="mb-4" key={issueQuestion.id}>
        <div>
          {issueQuestion.question}
          {issueQuestion.answerFormat.required !== true && <span>(optional)</span>}
        </div>
        <RadioGroup
          className="mt-2"
          name={`issue-answer-${issueQuestion.id}`}
          selectedValue={
            this.state.answers[issueQuestion.id] === undefined ?
              null :
              this.state.answers[issueQuestion.id]
          }
          onChange={value => this.handleAnswerChange(issueQuestion.id, value)}
        >
          {issueQuestion.answerFormat.options.map(option => (
            <Radio
              key={`question-${issueQuestion.id}-option-${option.value}`}
              value={option.value}
              className="radio-item"
              label={option.label}
            />
          ))}
        </RadioGroup>
      </div>
    );
  }

  renderTextQuestion(issueQuestion) {
    return (
      <div className="mb-4" key={issueQuestion.id}>
        <div>
          <span>{issueQuestion.question}</span>
          {issueQuestion.answerFormat.required !== true && <small>&nbsp; *optional</small>}
        </div>
        <textarea
          value={
            this.state.answers[issueQuestion.id] === undefined ||
            this.state.answers[issueQuestion.id] == null ?
              '' :
              this.state.answers[issueQuestion.id]
          }
          className="form-control"
          id={`textarea-${issueQuestion.id}`}
          rows="6"
          placeholder=""
          onChange={e => this.handleAnswerChange(issueQuestion.id, e.target.value)}
        />
      </div>
    );
  }

  renderForm() {
    return this.props.issueQuestions.issueQuestions.map(issueQuestion => {
      if (issueQuestion.answerFormat.type === 'radio') {
        return this.renderRadioField(issueQuestion);
      }
      if (issueQuestion.answerFormat.type === 'textarea') {
        return this.renderTextQuestion(issueQuestion);
      }

      return null;
    });
  }

  render() {
    if (this.props.issueQuestions.status === 'SUBMISSION_ERROR') {
      console.log('SUBMISSION_ERROR:', this.props.issueQuestions.error);
    }

    return (
      <div className="IssueSurvey d-flex justify-content-center">
        <div className="col-auto">
          <div className="row mt-2 mb-2">
            <BackLink href="/report-problem" text="Report a different problem" />
          </div>
          <div className="row mb-2">
            <div className="card">
              <div className="issue-title mt-4">
                {this.props.location.state.issueType.shortName}
              </div>
              <div className="mt-4 mb-4">
                <strong>
                  Please answer the following to help us resolve your issue. Your teacher won&#39;t see
                  this.
                </strong>
              </div>

              {/* TODO: Dry this with alerts and figure out a proper alert UI */}
              {this.props.issueQuestions.status === 'FAIL' && <div>Problem loading questions</div>}

              {/* TODO: className shouldn't be reservations? do you need that div? */}
              {(this.props.issueQuestions.status === null ||
                this.props.issueQuestions.status === 'LOADING') && <Loading />}

              {(this.props.issueQuestions.status === 'SUCCESS' ||
                this.props.issueQuestions.status === 'SUBMITTING' ||
                this.props.issueQuestions.status === 'SUBMISSION_ERROR') && (
                <form className="UpdateUserProfileForm form">
                  {this.renderForm()}

                  <label className="m-0 btn-cursor">
                    <Checkbox
                      name="request-refund"
                      checked={this.state.refundRequested}
                      onChange={this.handleRequestRefund}
                    />
                    &nbsp; Would you like to request a refund from your teacher?
                  </label>
                  <div>
                    <small>
                      If so, we will share the problem you experienced but all details in this form
                      will remain private
                    </small>
                  </div>

                  <div className="mt-4">
                    <button
                      className="btn btn-primary"
                      type="button"
                      disabled={this.isSubmitDisabled()}
                      onClick={this.handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    issueQuestions: state.issueQuestions
  };
}

export default connect(
  mapStateToProps,
  { getIssueQuestions, answerIssueSurvey }
)(IssueSurvey);



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/routes/IssueSurvey/index.js